namespace TabAurous.OMS {
    export interface CheckListForm {
        CheckListTypeId: Serenity.LookupEditor;
        CheckListName: Serenity.StringEditor;
    }

    export class CheckListForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CheckList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CheckListForm.init)  {
                CheckListForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CheckListForm, [
                    'CheckListTypeId', w0,
                    'CheckListName', w1
                ]);
            }
        }
    }
}
